import React, { useState } from 'react';

export default function Widget(props) {
    const className = (props.border === false || props.border === 'false' ? ' border-0 ' : ' card classification-card ')
        + (props.className || '');

    return (
        <div className={className}>
            <div className="card-body">
                {props.children}
            </div>
        </div>
    );
}